import { render } from "./verification-modal.vue?vue&type=template&id=24c71805&scoped=true"
import script from "./verification-modal.vue?vue&type=script&lang=js"
export * from "./verification-modal.vue?vue&type=script&lang=js"

import "./verification-modal.vue?vue&type=style&index=0&id=24c71805&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c71805"]])

export default __exports__